import { useCookie, useRuntimeConfig } from '#imports';
import { redirectCookiePath } from '~/utils/baseUrl';

/** Where to return after sign-in: a router path with its query and hash (`route.fullPath`),
 * never a document path — the login page resolves it against the base. */
export const useRedirectPath = () =>
  useCookie<string | null>('redirectPath', {
    path: redirectCookiePath(useRuntimeConfig().app.baseURL),
  });
